export enum Routes {
    ACCESS = 'access',
    PLAY = 'play',
    GAME = 'game',
    PREVIEW = 'preview',
}
